import { z } from 'zod';
function parseString(value) {
    return z.string().parse(value);
}
function retrieve(key, transform) {
    const rawValue = localStorage.getItem(formatKey(key));
    if (rawValue == null) {
        return undefined;
    }
    const value = JSON.parse(rawValue);
    return transform ? transform(value) : parseString(value);
}
export function safeRetrieve(key, transform) {
    try {
        return retrieve(key, transform);
    }
    catch (e) {
        console.warn('Failed to retrieve a value from local storage', e);
    }
}
function store(key, value) {
    if (value == null) {
        localStorage.removeItem(formatKey(key));
    }
    else {
        localStorage.setItem(formatKey(key), JSON.stringify(value));
    }
}
export function safeStore(key, value) {
    try {
        store(key, value);
    }
    catch (e) {
        console.warn('Failed to store a value in local storage', e);
    }
}
function formatKey(key) {
    return `streamrtv-${key}`;
}
